import { render, staticRenderFns } from "./Oops.pug?vue&type=template&id=0dbf0fd0&scoped=true&lang=pug&"
import script from "./Oops.vue?vue&type=script&lang=js&"
export * from "./Oops.vue?vue&type=script&lang=js&"
import style0 from "./Oops.scss?vue&type=style&index=0&id=0dbf0fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbf0fd0",
  null
  
)

export default component.exports